import React from "react";
import { Button, ButtonGroup, Text } from "@flixbus/honeycomb-react";
import type { ChatMessage } from "./chatMessages";
import { toFailureCopy, hasSpecificErrorCopy } from "./chatCopy";
import styles from "./ChatMessage.module.scss";

export interface FailedBodyProps {
  message: Extract<ChatMessage, { role: "assistant"; kind: "failed" }>;
  onRetry: () => void;
}

/** Failed bubble: a specific-error message hides the raw AI summary; retryable
 *  errors offer an inline Retry, otherwise the user continues in the composer. */
const FailedBody: React.FC<FailedBodyProps> = ({ message, onRetry }) => (
  <>
    <Text extraClasses={styles.bubbleText}>
      {toFailureCopy(message.errorCode)}
    </Text>
    {!hasSpecificErrorCopy(message.errorCode) && message.summary && (
      <Text small extraClasses={styles.assistantMeta}>
        {message.summary}
      </Text>
    )}
    {message.retryable && (
      <ButtonGroup extraClasses={styles.bubbleActions}>
        <Button appearance="primary" onClick={onRetry}>
          Retry
        </Button>
      </ButtonGroup>
    )}
  </>
);

export default React.memo(FailedBody);
